<template>

  <div class="flex min-h-screen flex-col bg-slate-50">
    <GeneralItemsBanner
      message="This is a demo app, Order placed will not be delivered physically.  This app is designed to showcase the features and functionality of our platform" />

    <AppBar />
    <div class="px-[6%]">

      <Categories></Categories>
      <slot />
    </div>
    <UNotifications />
    <LazyAppFooter />
  </div>


</template>

<style scoped>
/* Add any global styles for your layout here */
</style>
<style>
body {
  font-family: 'Bitter', 'Open Sans', sans-serif;
}
</style>
